module.exports = __webpack_public_path__ + "static/img/ex_3.6f59d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_3.png
// module id = LTEx
// module chunks = 1